exports.years = () => {
  const start = 2018;
  const current = new Date().getFullYear();
  let year = [];
  for (let i = start; i <= current; i++) {
    year.push(i);
  }
  return year;
};

exports.checkStatus = () => {
  const daex = localStorage.getItem("_daex");
  let dttt = new Date().getTime() - parseInt(daex);
  if (parseInt(dttt) > 36000000 || parseInt(dttt) < 0 || !daex) {
    return false;
  } else {
    return true;
  }
};
